const hideDisplay = (component: false|JSX.Element) => (false && component);

export default hideDisplay;